import { Grid, Bones, Box, useTheme } from '@simplywallst/ui-core';
import { KeyMetric } from '@/components/KeyMetric';

export const LoadingState = () => {
  const theme = useTheme();

  return (
    <Box
      borderRadius="x1"
      overflow="hidden"
      role="progressbar"
      aria-label="Loading Narrative Card"
      aria-busy="true"
    >
      <Grid backgroundColor="spaceGray" padding="x2" gap={`${theme.x2}px`}>
        <Grid
          templateColumns="max-content max-content"
          justifyContent="space-between"
        >
          <Grid
            templateColumns="max-content max-content"
            gap={`${theme.x1}px`}
            alignItems="center"
          >
            <Grid>
              <Bones
                minWidth="32px"
                minHeight="32px"
                maxWidth="32px"
                maxHeight="32px"
                borderRadius="x2"
              />
            </Grid>
            <Grid templateRows="max-content max-content" gap={`${theme.x1}px`}>
              <Bones minWidth="144px" minHeight="24px" />
              <Bones maxWidth="60%" minHeight="12px" />
            </Grid>
          </Grid>
          <Bones
            minWidth="96px"
            minHeight="32px"
            maxHeight="32px"
            borderRadius="x0_75"
          />
        </Grid>
        <Grid templateRows="max-content max-content" gap={`${theme.x1}px`}>
          <Bones minHeight="24px" />
          <Bones maxWidth="80%" minHeight="24px" />
        </Grid>
      </Grid>
      <Grid backgroundColor="phantom" padding="x2" gap={`${theme.x2}px`}>
        <Grid templateColumns="1fr 1fr" gap={`${theme.x2}px`}>
          <KeyMetric color="transparentSubtle">
            <Grid templateRows="max-content max-content" gap={`${theme.x1}px`}>
              <Bones minWidth="120px" minHeight="24px" />
              <Bones minWidth="72px" maxWidth="72px" minHeight="12px" />
            </Grid>
          </KeyMetric>
          <KeyMetric color="transparentSubtle">
            <Grid templateRows="max-content max-content" gap={`${theme.x1}px`}>
              <Bones minWidth="120px" minHeight="24px" />
              <Bones minWidth="72px" maxWidth="72px" minHeight="12px" />
            </Grid>
          </KeyMetric>
        </Grid>
        <Grid
          templateColumns="1fr 1fr"
          gap={`${theme.x2}px`}
          justifyContent="space-between"
        >
          <Grid
            templateColumns="max-content max-content max-content"
            gap={`${theme.x2}px`}
            justifyContent="start"
          >
            <Grid
              templateColumns="min-content min-content"
              placeContent="center"
              gap={`${theme.x0_5}px`}
            >
              <Bones minWidth="32px" minHeight="24px" />
            </Grid>
            <Grid
              templateColumns="min-content min-content"
              placeContent="center"
              gap={`${theme.x0_5}px`}
            >
              <Bones minWidth="32px" minHeight="24px" />
            </Grid>
            <Grid
              templateColumns="min-content min-content"
              placeContent="center"
              gap={`${theme.x0_5}px`}
            >
              <Bones minWidth="32px" minHeight="24px" />
            </Grid>
          </Grid>
          <Grid
            templateColumns="max-content"
            gap={`${theme.x2}px`}
            justifyContent="end"
          >
            <Bones minWidth="64px" minHeight="24px" />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
